import { useState, useEffect } from 'react';
import { Slider } from '../Slider';

type NumberControlProps = {
    id: string;
    label: string;
    value: number;
    min?: number;
    max?: number;
    step?: number;
    onChange: (newValue: number) => void;
};

export const NumberControl = ({ id: _id, label, value, min = 0, max = 100, step = 0.1, onChange }: NumberControlProps) => {
    const [internalValue, setInternalValue] = useState(value);

    // This effect synchronizes the internal state with external changes to the `value` prop.
    // This is crucial for when the value is changed by code, not by the user dragging the slider.
    useEffect(() => {
        setInternalValue(value);
    }, [value]);

    const handleSliderChange = (newValue: number) => {
        // Update the internal state immediately for a smooth UI response.
        setInternalValue(newValue);
        // Propagate the change to the parent component to update the actual property.
        onChange(newValue);
    };

    return (
        <Slider
            label={label}
            value={internalValue}
            min={min}
            max={max}
            step={step}
            onChange={handleSliderChange}
        />
    );
};
